/**
 * Setea el listado de enterprises.
 *
 * @param {*} state
 * @param {*} enterprises
 */
export function setEnterprises(state, enterprises) {
  state.enterprises = enterprises;
}
